import React from 'react';
import { NavLink } from 'react-router-dom';

const ListItemLink = React.forwardRef((props, ref) => (
  <NavLink activeClassName='Mui-selected' innerRef={ref} {...props} />
));

export default ListItemLink;
